{
	"asset": {
		"generator": "Khronos glTF Blender I/O v4.1.62",
		"version": "2.0"
	},
	"extensionsUsed": ["KHR_materials_specular"],
	"scene": 0,
	"scenes": [
		{
			"name": "Scene",
			"nodes": [0]
		}
	],
	"nodes": [
		{
			"mesh": 0,
			"name": "Cube.001",
			"scale": [0.2995975613594055, 0.2995975613594055, 0.2995975613594055],
			"translation": [0, 0.3282511532306671, 0]
		}
	],
	"materials": [
		{
			"doubleSided": true,
			"extensions": {
				"KHR_materials_specular": {
					"specularColorFactor": [1.2285715341567993, 1.2285715341567993, 1.2285715341567993]
				}
			},
			"name": "metal",
			"pbrMetallicRoughness": {
				"baseColorFactor": [0.0016949522541835904, 0.8294659852981567, 0.26296669244766235, 1],
				"metallicFactor": 0.5275590419769287,
				"roughnessFactor": 0.18787401914596558
			}
		},
		{
			"doubleSided": true,
			"name": "wood",
			"pbrMetallicRoughness": {
				"baseColorFactor": [0.49394458532333374, 0.0029026190750300884, 0.24832803010940552, 1],
				"metallicFactor": 0,
				"roughnessFactor": 0.7914285659790039
			}
		},
		{
			"doubleSided": true,
			"name": "Material",
			"pbrMetallicRoughness": {
				"baseColorFactor": [0.28494957089424133, 0.02045438624918461, 0.8034002780914307, 1],
				"metallicFactor": 0.5590550899505615,
				"roughnessFactor": 0.16141733527183533
			}
		},
		{
			"doubleSided": true,
			"name": "Material.001",
			"pbrMetallicRoughness": {
				"baseColorFactor": [0.01434984989464283, 1, 1, 1],
				"metallicFactor": 0.5039370059967041,
				"roughnessFactor": 0.27952754497528076
			}
		}
	],
	"meshes": [
		{
			"name": "Cube.003",
			"primitives": [
				{
					"attributes": {
						"POSITION": 0,
						"NORMAL": 1,
						"TEXCOORD_0": 2
					},
					"indices": 3,
					"material": 0
				},
				{
					"attributes": {
						"POSITION": 4,
						"NORMAL": 5,
						"TEXCOORD_0": 6
					},
					"indices": 7,
					"material": 1
				},
				{
					"attributes": {
						"POSITION": 8,
						"NORMAL": 9,
						"TEXCOORD_0": 10
					},
					"indices": 11,
					"material": 2
				},
				{
					"attributes": {
						"POSITION": 12,
						"NORMAL": 13,
						"TEXCOORD_0": 14
					},
					"indices": 15,
					"material": 3
				}
			]
		}
	],
	"accessors": [
		{
			"bufferView": 0,
			"componentType": 5126,
			"count": 268,
			"max": [4.751615047454834, 19.992334365844727, 0.6906017661094666],
			"min": [-4.537655353546143, 0.310330867767334, -1.3093981742858887],
			"type": "VEC3"
		},
		{
			"bufferView": 1,
			"componentType": 5126,
			"count": 268,
			"type": "VEC3"
		},
		{
			"bufferView": 2,
			"componentType": 5126,
			"count": 268,
			"type": "VEC2"
		},
		{
			"bufferView": 3,
			"componentType": 5123,
			"count": 456,
			"type": "SCALAR"
		},
		{
			"bufferView": 4,
			"componentType": 5126,
			"count": 185,
			"max": [4.751615047454834, 7.441022872924805, 0.8636838793754578],
			"min": [-4.537655353546143, 0.310330867767334, -1.4824802875518799],
			"type": "VEC3"
		},
		{
			"bufferView": 5,
			"componentType": 5126,
			"count": 185,
			"type": "VEC3"
		},
		{
			"bufferView": 6,
			"componentType": 5126,
			"count": 185,
			"type": "VEC2"
		},
		{
			"bufferView": 7,
			"componentType": 5123,
			"count": 381,
			"type": "SCALAR"
		},
		{
			"bufferView": 8,
			"componentType": 5126,
			"count": 88,
			"max": [2.8620359897613525, 19.992334365844727, 0.6906017661094666],
			"min": [-2.648076295852661, 7.2825927734375, -1.3093981742858887],
			"type": "VEC3"
		},
		{
			"bufferView": 9,
			"componentType": 5126,
			"count": 88,
			"type": "VEC3"
		},
		{
			"bufferView": 10,
			"componentType": 5126,
			"count": 88,
			"type": "VEC2"
		},
		{
			"bufferView": 11,
			"componentType": 5123,
			"count": 138,
			"type": "SCALAR"
		},
		{
			"bufferView": 12,
			"componentType": 5126,
			"count": 60,
			"max": [1.1069798469543457, 16.74031639099121, 0.6906017661094666],
			"min": [-0.8930200934410095, 4.907893180847168, -1.3093981742858887],
			"type": "VEC3"
		},
		{
			"bufferView": 13,
			"componentType": 5126,
			"count": 60,
			"type": "VEC3"
		},
		{
			"bufferView": 14,
			"componentType": 5126,
			"count": 60,
			"type": "VEC2"
		},
		{
			"bufferView": 15,
			"componentType": 5123,
			"count": 120,
			"type": "SCALAR"
		}
	],
	"bufferViews": [
		{
			"buffer": 0,
			"byteLength": 3216,
			"byteOffset": 0,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 3216,
			"byteOffset": 3216,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 2144,
			"byteOffset": 6432,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 912,
			"byteOffset": 8576,
			"target": 34963
		},
		{
			"buffer": 0,
			"byteLength": 2220,
			"byteOffset": 9488,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 2220,
			"byteOffset": 11708,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 1480,
			"byteOffset": 13928,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 762,
			"byteOffset": 15408,
			"target": 34963
		},
		{
			"buffer": 0,
			"byteLength": 1056,
			"byteOffset": 16172,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 1056,
			"byteOffset": 17228,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 704,
			"byteOffset": 18284,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 276,
			"byteOffset": 18988,
			"target": 34963
		},
		{
			"buffer": 0,
			"byteLength": 720,
			"byteOffset": 19264,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 720,
			"byteOffset": 19984,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 480,
			"byteOffset": 20704,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 240,
			"byteOffset": 21184,
			"target": 34963
		}
	],
	"buffers": [
		{
			"byteLength": 21424,
			"uri": "gamer%20sword.bin"
		}
	]
}
